
import { useNotification } from '@spotted-zebra-uk/ui-components';

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { notificationContainer } = useNotification();

  return (
    <>
      {notificationContainer()}
      {children}
    </>
  );
};
